// const caseManage = () => import('@/view/article/case-manage');
// const informationRelease = () => import('@/view/article/information-release');
// const problem = () => import('@/view/article/problem');

export default [
//   {
//   path: '/case-manage',
//   name: 'caseManage',
//   component: caseManage
// }, {
//   path: '/information-release',
//   name: 'informationRelease',
//   component: informationRelease
// }, {
//   path: '/problem',
//   name: 'problem',
//   component: problem
// }
];